import {
  Header,
  MenuItem,
  ContactCapital,
  InvestmentProcess,
  MainCard,
  Input,
  Button,
  ApplicationSentModal,
} from 'components/CapitalRevamp';
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { investmentAction } from 'actions/capital';
import { connect } from 'react-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import styles from './Investment.css';

class Investment extends Component {
  state = {
    showModal: false,
  };

  componentDidMount() {
    const { pageCheck } = this.props;
    pageCheck(browserHistory);
  }

  showModal = () => {
    this.setState({ showModal: true });
  };

  hideModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { showModal } = this.state;
    const { showLoadingSpinnerPage } = this.props;
    return (
      <div>
        <Header />
        <MenuItem
          back
          title="Kembali ke Produk"
          onClick={() => browserHistory.push('/capital')}
        />
        {showLoadingSpinnerPage && <NoDataAndLoading showLoadingSpinner />}
        {!showLoadingSpinnerPage && (
          <div className={styles['content-wrapper']}>
            <div className={styles.row}>
              <div className={styles['form-wrapper']}>
                <MainCard border="green" title="Form Aplikasi">
                  <div className={styles['content-form']}>
                    <p className={styles.note}>*Semua Wajib Diisi</p>
                    <Input label="Nama Bisnis" />
                    <Input label="Nama Pemilik Bisnis" />
                    <Input label="Nomor Handphone Pemilik Bisnis" />
                    <Input label="Email Teregistrasi di Moka" />
                    <Input label="Lama Berdirinya Bisnis" />
                    <Input label="Tujuan Pendanaan" />
                    <div className={styles['form-action']}>
                      <Button
                        title="Temukan Investor"
                        onClick={this.showModal}
                      />
                    </div>
                  </div>
                </MainCard>
              </div>
            </div>
            <div className={styles.line} />
            <div className={styles.row}>
              <div className={styles['process-wrapper']}>
                <InvestmentProcess />
              </div>
              <ContactCapital />
            </div>
          </div>
        )}
        {showModal && (
          <ApplicationSentModal
            hideModal={this.hideModal}
            content="Terima kasih telah mengajukan pendanaan melalui Moka Capital - Santara!"
            info="Telesales Moka Capital akan segera menghubungi anda dalam waktu 1-2 hari kerja"
            buttonText="Kembali ke halaman Investment"
          />
        )}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    pageCheck: value => dispatch(investmentAction.pageCheck(value)),
  };
}

function mapStateToProps(state) {
  const { showLoadingSpinnerPage } = state.loadingSpinner;

  return {
    showLoadingSpinnerPage,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Investment);
